import React, { useState, useEffect } from 'react';
import { PhoneInput } from 'react-international-phone';
import 'react-international-phone/style.css';
import { validatePhoneComprehensive, debugPhoneValidation } from '../../Utils/helperFunction';
import { useCallback } from 'react';

const ValidatedPhoneInput = ({
  value,
  onChange,
  onValidationChange,
  defaultCountry = 'us',
  disabled = false,
  name = 'phone',
  className = '',
  placeholder = '',
  showValidation = false, // New prop to control when to show validation
  onBlur,
  ...props
}) => {
  const [phone, setPhone] = useState(value || '');
  const [country, setCountry] = useState(null);
  const [validation, setValidation] = useState({
    isValid: true,
    error: ''
  });

  useEffect(() => {
    if (value !== phone) {
      setPhone(value || '');
    }
  }, [value]);



  const handleValidate = (phoneValue, countryData) => {
    // Only validate if there's a phone value and country data
    if (phoneValue && phoneValue.length > 0 && countryData) {
      try {
        const validationResult = validatePhoneComprehensive(phoneValue, countryData?.country);
        setValidation(validationResult);
        
        if (onValidationChange) {
          onValidationChange(validationResult);
        }
      } catch (error) {
        console.log('Validation error in component:', error);

        // Debug the validation issue
        debugPhoneValidation(phoneValue, countryData);

        // Fallback validation
        const fallbackValidation = {
          isValid: phoneValue.length >= 7,
          error: phoneValue.length < 7 ? "Phone number is too short" : ""
        };
        setValidation(fallbackValidation);

        if (onValidationChange) {
          onValidationChange(fallbackValidation);
        }
      }
    } else {
      // If phone is empty or no country, set as valid (no error)
      const newValidation = {
        isValid: true,
        error: ''
      };
      setValidation(newValidation);

      if (onValidationChange) {
        onValidationChange(newValidation);
      }
    }
  }

  const handlePhoneChange = (phoneValue, countryData) => {
    setPhone(phoneValue);
    setCountry(countryData);

    handleValidate(phoneValue, countryData)

    if (onChange) {
      onChange(phoneValue, countryData);
    }
  };

  const handleBlur = (props) => {
    handleValidate(phone, country)
    if (onBlur) {
      onBlur()
    }
  }



  return (
    <div className={`validated-phone-input ${className}`}>
      <PhoneInput
        defaultCountry={defaultCountry}
        value={phone}
        onChange={handlePhoneChange}
        disabled={disabled}
        name={name}
        onBlur={handleBlur}
        placeholder={placeholder}
        {...props}
      />
      {showValidation && validation.error && phone.length > 0 && (
        <div className="phone-validation-error" style={{
          color: 'red',
          fontSize: '14px',
          marginTop: '4px',
          marginBottom: '4px'
        }}>
          {validation.error}
        </div>
      )}
    </div>
  );
};

export default ValidatedPhoneInput; 